import React, { useEffect } from "react";
import BannerHome from "./BannerHome";
import AuctionAndExhibition from "./AuctionAndExhibition";
import Publication from "./Publication";
import Video from "./Video";
import HowTosell from "./HowTosell";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import SensorsIcon from "@mui/icons-material/Sensors";
import useMediaQuery from "@mui/material/useMediaQuery";


import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { Divider } from "@mui/material";

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

function Home(props) {

  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const matchesPhone = useMediaQuery("(min-width:700px)");


  const [open, setOpen] = React.useState(false);


  const handleClose = () => {
    setOpen(!open);
  };


//   const callMeta = async () => {
//     let dataSend = {
//       title: 'Leon Gallery | Premier Philippine Art Gallery & Auction House',
//       discription: 'Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions.',
//       lotNo: '',
//       canonical: 'https://leon-gallery.com/home',
//       url: 'https://leon-gallery.com/home',
//       imagUrl: 'https://leon-gallery.com/static/media/dddd.f96bbcbee8c8c2f5e3ee.png',
//     };

//     await fetch(`http://localhost:8081/`, {
//       method: "POST",
//       body: JSON.stringify(dataSend),
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("data send here ", data);
//       })
//       .catch((error) => {
//         // alert.error(error)
//         console.log("error ", error);
//       });
//   }


// useEffect(() => {
// return callMeta();
// },[])

  return (
    <div className="boxed_wrapper">
      <BannerHome />

  {open === false ?  <div

     aria-labelledby="draggable-dialog-title"
        style={{
          position: "fixed",
          bottom:  matchesPhone === true ?  0:100,
          right: '0%',
          marginRight: '-275px',
          padding: 2,
          borderRadius: 5,
          cursor: 'pointer',
          zIndex: 99999,
          margin: matchesPhone === true ? 5 : 0,
        }}
        open={true}
        onClose={handleClose}
      >
      {/* <div
      onClick={handleClose}
        style={{
          background: "red",
          color: "white",
          width: 60,
          height: 60,
          borderRadius: 60,
          textAlign: "center",
          fontSize:  20,
          lineHeight: "55px",
          
        }}
      >
      <VideocamIcon style={{ fontSize: 35}}/>
      </div> */}


  </div> :  <Dialog
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
         style={{
          //  position: "fixed",
          //  top: "100px",
          //  width: matchesPhone === true ? "580px" : "100%",
      
          //  // padding:' 5px 5px',
          //  borderRadius: 5,
          //  zIndex: 99999,
          //  background: "rgb(242 242 242)",

           margin: matchesPhone === true ? 5 : 0,
         }}
         fullWidth={fullWidth}
         maxWidth={maxWidth}
         open={true}
         onClose={handleClose}
       > 

 <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <div
          id="draggable-dialog-title"
            style={{
              background: "red",
              color: "white",
              width: 80,
              padding: 2,
              borderRadius: 5,
              textAlign: "center",
              fontSize:  14,
              cursor: 'move' 
            }}
          >
            <SensorsIcon />
            LIVE
          </div>
        </DialogTitle>
        <DialogContent>
          <div style={{      width:  "100%",}}>
            <iframe
              id="ifvideo"
              width="100%"
              height={`${matchesPhone === true ? "380" : "100%"}`}
              scrolling="no"
              frameborder="0"
              allowfullscreen=""
              src="https://demo.nanocosmos.de/nanoplayer/embed/1.3.3/nanoplayer.html?entry.rtmp.streamname=TKGUW-bCyQT&amp;playback.latencyControlMode=balancedadaptive"
            ></iframe>
          </div>
        </DialogContent>
        <Divider></Divider>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions> 
      </Dialog> }

      <AuctionAndExhibition />

      <Publication />
      <Video />
      <HowTosell />
      {/* <FormEmail/> */}
    </div>
  );
}

export default Home;
